import { Navigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { elevatedAccessApi } from '../../services/elevatedAccessService';

/**
 * Gates Authorisations UI to elevated principals (default: super_admin).
 */
export function RequireElevated({ children }) {
  const { user, loading: authLoading } = useAuth();
  const [state, setState] = useState({ loading: true, allowed: false });

  useEffect(() => {
    let cancelled = false;
    const run = async () => {
      if (authLoading) return;
      if (!user) {
        if (!cancelled) setState({ loading: false, allowed: false });
        return;
      }
      try {
        const me = await elevatedAccessApi.getMyAccess();
        if (!cancelled) {
          setState({ loading: false, allowed: Boolean(me.is_elevated) });
        }
      } catch {
        if (!cancelled) {
          setState({
            loading: false,
            allowed: user.role === 'super_admin',
          });
        }
      }
    };
    void run();
    return () => {
      cancelled = true;
    };
  }, [user, authLoading]);

  if (authLoading || state.loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#003380]" />
      </div>
    );
  }

  if (!user) return <Navigate to="/admin/login" replace />;
  if (!state.allowed) return <Navigate to="/admin/dashboard" replace />;
  return children;
}
